export default __webpack_public_path__ + "static/media/FeedbackIcon.094038d0.svg";